module.exports = __webpack_public_path__ + "static/media/4644.e0375dad.jpg";